const SDK_VERSION = '7.120.4';
export { SDK_VERSION };